<div class="game-timeline-filters" *ngIf="game.status === gameStatuses.closed">
  <a
    [ngClass]="{active: !selectedPeriod}"
    (click)="selectedPeriod = null"
  >Все</a>
  <a
    *ngFor="let period of periods"
    [ngClass]="{active: selectedPeriod === period}"
    (click)="selectedPeriod = period"
  >{{ period }} период</a>
  <a
    [ngClass]="{active: selectedPeriod === period}"
    (click)="selectedPeriod = period"
    *ngFor="let period of overtimePeriods"
  >
    <ng-container *ngIf="period === game.hockeyGameConfig.overtimePeriod">Овертайм</ng-container>
    <ng-container *ngIf="period === game.hockeyGameConfig.bullitsPeriod">Буллиты</ng-container>
    <ng-container *ngIf="period === game.hockeyGameConfig.playoffOvertimePeriod">Овертайм на победителя серии</ng-container>
    <ng-container *ngIf="period === game.hockeyGameConfig.playoffBullitsPeriod">Буллиты на победителя серии</ng-container>
  </a>
  <div class="right-filters">
    <a
      *ngIf="fibaButton"
      [ngClass]="{active: onlyHighlights}"
      class="fiba-btn"
      (click)="toggleOnlyHighlights()"
    >Highlights</a>
    <a
      [ngClass]="{active: onlyScoreLogs}"
      class="fiba-btn"
      (click)="toggleOnlyScoreLogs()"
    >Только шайбы</a>
  </div>
</div>
<div class="game-timeline">
  <div class="heading"
    *ngIf="game.status === gameStatuses.closed && !selectedPeriod && sort === 'desc'"
  >
    Игра завершена
  </div>
  <ng-container
    *ngFor="let item of gameLogs; trackBy: identify; let i=index"
  >
    <ng-container
      *ngIf="!selectedPeriod || selectedPeriod === item.period"
    >
      <div class="heading" *ngIf="(i === 0 || gameLogs[i - 1].period != item.period) && sort === 'asc'">
        <ng-container *ngIf="item.period <= game.hockeyGameConfig.periodsCount">{{ item.period }} период</ng-container>
        <ng-container *ngIf="item.period === game.hockeyGameConfig.overtimePeriod">Овертайм</ng-container>
        <ng-container *ngIf="item.period === game.hockeyGameConfig.bullitsPeriod">Буллиты</ng-container>
        <ng-container *ngIf="item.period === game.hockeyGameConfig.playoffOvertimePeriod">Овертайм на победителя серии</ng-container>
        <ng-container *ngIf="item.period === game.hockeyGameConfig.playoffBullitsPeriod">Буллиты на победителя серии</ng-container>
      </div>
      <mtg-hockey-game-timeline-item
        *ngIf="(!onlyScoreLogs || isScoreLog(item)) && (!onlyHighlights || item.isHighlight)"
        [game]="game"
        [gameLog]="item"
        [gameUsers]="gameUsers"
        class="timeline-item"
      ></mtg-hockey-game-timeline-item>
      <div class="heading" *ngIf="(!gameLogs[i + 1] || gameLogs[i + 1].period != item.period) && sort === 'desc'">
        <ng-container *ngIf="item.period <= game.hockeyGameConfig.periodsCount">{{ item.period }} период</ng-container>
        <ng-container *ngIf="item.period === game.hockeyGameConfig.overtimePeriod">Овертайм</ng-container>
        <ng-container *ngIf="item.period === game.hockeyGameConfig.bullitsPeriod">Буллиты</ng-container>
        <ng-container *ngIf="item.period === game.hockeyGameConfig.playoffOvertimePeriod">Овертайм на победителя серии</ng-container>
        <ng-container *ngIf="item.period === game.hockeyGameConfig.playoffBullitsPeriod">Буллиты на победителя серии</ng-container>
      </div>
    </ng-container>
  </ng-container>
  <div class="heading"
       *ngIf="game.status === gameStatuses.closed && !selectedPeriod && sort === 'asc'"
  >
    Игра завершена
  </div>
</div>
